module.exports = __webpack_public_path__ + "img/flag_ru.210edbc0.svg";